/**
 * Sysadmin Library — /sysadmin/library/articles redirect (Library-PR-X2).
 *
 * The pre-X2 Articles entity-tab has been collapsed into the unified
 * Documents tab. This route exists ONLY to keep bookmarks and external
 * links working: it 302-redirects to /sysadmin/library/documents.
 *
 * The original article authoring + lifecycle UI lives at
 * /sysadmin/library/documents (with kindFilter='article' available
 * via the Type filter Select).
 */

import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/sysadmin/library/articles')({
  beforeLoad: () => {
    throw redirect({ to: '/sysadmin/library/documents', replace: true });
  },
});
